"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStorage = exports.getStorage = exports.getFirebase = void 0;
function getFirebase() {
    return firebase;
}
exports.getFirebase = getFirebase;
function getStorage(key) {
    return localStorage.getItem(key);
}
exports.getStorage = getStorage;
function setStorage(key, value) {
    localStorage.setItem(key, value);
}
exports.setStorage = setStorage;
